import { createContext } from 'react';

export const GalleriaRefContext = createContext(null);
